<template>
  <div class="NavbarItemDropdown">
    <div class="dropdownContent">
      <div class="menuEntries">
        <DropdownMenuProducts v-if="content.groupings.length === 1"
          :entries="content.groupings[0].entries"
        />
        <DropdownMenuStandard v-else
          :groupings="content.groupings"
        />
      </div>
      <div class="featuredItemsPane">
        <div v-if="content.featuredItems" class="featuredItems">
          <FeaturedItem v-for="item in content.featuredItems"
            :key="item._key"
            :content="item"
            :includeDescription="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DropdownMenuProducts from './DropdownMenuProducts.vue'
import DropdownMenuStandard from './DropdownMenuStandard.vue'
import FeaturedItem from '../shared/FeaturedItem.vue'

export default {
  components: {
    DropdownMenuProducts,
    DropdownMenuStandard,
    FeaturedItem,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>

.NavbarItemDropdown {
  position: absolute;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  z-index: 10;

  /*
    Make the dropdown overlap the navbar so that when the visitor moves their cursor down to
    the dropdown menu it's less likely to disappear if they don't go straight down.
  */
  --navbar-overlap: 1.25rem;
  top: calc(var(--navbar-height) - var(--navbar-overlap));
  padding-top: var(--navbar-overlap);
}

.dropdownContent {
  border-top: thin solid var(--hairline-color);
  display: flex;
}

.menuEntries {
  flex-basis: 60%;
  padding-top: var(--spacing-9);
  padding-right: var(--spacing-9);
  padding-bottom: var(--spacing-12);
  padding-left: var(--gutter-width);
  background-color: var(--bg-color-white);
}

.featuredItemsPane {
  flex-basis: 40%;
  padding-top: var(--spacing-9);
  padding-right: var(--gutter-width);
  padding-bottom: var(--spacing-12);
  padding-left: var(--spacing-9);
  background-color: var(--bg-color-pale-gray);
  border-left: thin solid var(--hairline-color);
}

.featuredItems {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-6);
}
</style>
